import { types } from "mobx-state-tree";

export const timeZoneList = [
    {
        display: "System",
        zone: "system"
    },
    {
        display: "Redmond",
        zone: "America/Los_Angeles"
    },
    {
        display: "Boston",
        zone: "America/New_York"
    },
    {
        display: "London",
        zone: "Europe/London"
    },
    {
        display: "CET (Norway)",
        zone: "Europe/Berlin"
    },
    {
        display: "IST (India)",
        zone: "Asia/Kolkata"
    },
    {
        display: "CST (Suzhou)",
        zone: "Asia/Shanghai"
    },
    {
        display: "UTC/GMT",
        zone: "UTC"
    }
] as const;

export const TimeStore = types
    .model("timeSettingStore", {
        selectedTimeZone: timeZoneList[0].zone
    })
    .actions((self) => ({
        setSelectedTimeZone(value: string) {
            self.selectedTimeZone = value;
        }
    }));
